export const switchLanguageInPath = (currentPath: string, currentLang: string, newLang: string): string => {
	// Split path into segments
	const segments = currentPath.split("/").filter(Boolean);
	
	// Remove current language if it's the first segment
	if (segments[0] === currentLang) {
		segments.shift();
	}
	
	// Build new path with new language
	return `/${newLang}${segments.length > 0 ? "/" + segments.join("/") : ""}`;
};